import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Circle, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { selectCurrentUserIconColor, setUserIconColor } from '../../../../../../../../../redux/modules/activityLog';
import { getUserInitials } from '../../../../../../../../../utils/userNameUtil';

const ActivityLogUserIcon = ({
  firstName,
  lastName,
  iconSize = '35px',
  fontSize = '14px'
}) => {
  const dispatch = useDispatch();
  const userInitials = getUserInitials(firstName, lastName);
  const userIcon = useSelector(selectCurrentUserIconColor(userInitials));

  useEffect(() => {
    dispatch(setUserIconColor(userInitials));
  });

  const getIconColor = () => {
    if (userIcon) return userIcon.appliedColor;
    return 'primaryScale.600';
  };

  return (
    <Tooltip label={userInitials}>
      <Circle bg={getIconColor()} color="white" fontSize={fontSize} fontWeight="600" size={iconSize}>
        { userInitials }
      </Circle>
    </Tooltip>
  );
};

ActivityLogUserIcon.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  iconSize: PropTypes.string,
  fontSize: PropTypes.string
};

export default ActivityLogUserIcon;
